import { useState, useEffect } from 'react';
import { usewpdataSelectors } from '../../../lib/wpdataState/selectors';
import s from './stockCountdown.module.scss';
import parse from 'html-react-parser';

const StockCountdown = ({ text, className, lowStockText, textColor }) => {
  const { hero } = usewpdataSelectors();

  const template =
    lowStockText || text || hero?.lowStockCountdownLabel || 'Low Stock | Order within XX:XX we will ship today!';

  const [timeLeft, setTimeLeft] = useState(600);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const minutes = Math.floor(timeLeft / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  const formattedTime = `${minutes}:${seconds}`;

  const label = template.replace(/XX:XX/g, formattedTime);

  return (
    <div className={`${s.description} ${className}`} style={{ color: textColor || hero?.styles?.textColorPrimary }}>
      <div className={s.stockContainer}>
        <div className={s.stock__bubble}></div>
        <span>{parse(label)}</span>
      </div>
    </div>
  );
};

export default StockCountdown;
